'use strict';

var cacheStore = new WeakMap();

var memoize = function memoize(fn) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$cacheKey = _ref.cacheKey,
      cacheKey = _ref$cacheKey === void 0 ? function (firstArgument) {
    return firstArgument;
  } : _ref$cacheKey,
      _ref$cache = _ref.cache,
      cache = _ref$cache === void 0 ? new Map() : _ref$cache;

  var memoized = function memoized() {
    var key = cacheKey.apply(this, arguments);

    if (cache.has(key)) {
      return cache.get(key).data;
    }

    var cacheItem = fn.apply(this, arguments);
    cache.set(key, {
      data: cacheItem
    });
    return cacheItem;
  };

  cacheStore.set(memoized, cache);
  return memoized;
};

var clear = function clear(fn) {
  if (!cacheStore.has(fn)) {
    throw new Error('Can\'t clear a function that was not memoized!');
  }

  var cache = cacheStore.get(fn);

  if (typeof cache.clear === 'function') {
    cache.clear();
  }
};

module.exports = {
  memoize: memoize,
  clear: clear
};